export class PropertiesConstants {
    static FORM_CONTROLS = {
        propertiesZoningLabel: "Property zoning",
        propertiesZoningFormControl: "propertiesZoningFormControl",
        propertiesSectionalTitleLabel: "Sectional scheme number",
        propertiesSectionalTitleControl: "propertiesSectionalTitleFormControl",
        propertiesUnitNumberLabel: "Unit number",
        propertiesUnitNumberControl: "propertiesUnitNumberFormControl",
        searchText: "Search",
        locationCemeteryLabel: "Select Cemetery",
        locationCemeteryFormControl: "locationCemeteryFormControl",
    };
    static SELECTED_PROPERTY_GRAPHICS_LAYER = "selectedPropertyGraphicsLayer";
    static ZONING_LOOKUP = "Zoning";
}
